export default __webpack_public_path__ + "img/pin_icons/general_healthcare_b.svg";